 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"avalon-themeWrapLive":"avalon-themeWrapLive","bb-themeWrap":"bb-themeWrap","bb-themeWrapLive":"bb-themeWrapLive","betcoinsportsxmb-themeWrapLive":"betcoinsportsxmb-themeWrapLive","betflip-themeWrapLive":"betflip-themeWrapLive","bmk-themeWrapLive":"bmk-themeWrapLive","liveComponent":"liveComponent","futurebet-themeWrapLive":"futurebet-themeWrapLive","hemingwaynew-themeWrapLive":"hemingwaynew-themeWrapLive","isiparyaj-themeWrapLive":"isiparyaj-themeWrapLive","lutrijabih-themeWrap":"lutrijabih-themeWrap","lutrijabihlive-themeWrap":"lutrijabihlive-themeWrap","playbetr-themeWrapLive":"playbetr-themeWrapLive","powerbet-themeWrap":"powerbet-themeWrap","powerbet-themeWrapLive":"powerbet-themeWrapLive","prematchModule":"prematchModule","sima-themeWrapLive":"sima-themeWrapLive","sportnaloterija-themeWrapLive":"sportnaloterija-themeWrapLive","themeWrap":"themeWrap","themeWrapLive":"themeWrapLive","themeWrapLiveLight":"themeWrapLiveLight","topbet-themeWrap":"topbet-themeWrap","victory-themeWrapLive":"victory-themeWrapLive","wettnet-themeWrapLive":"wettnet-themeWrapLive","winner-themeWrap":"winner-themeWrap","liveModule":"liveModule","seven-theme":"seven-theme","winner-theme":"winner-theme","winnerbet-theme":"winnerbet-theme"}[chunkId]||chunkId) + "." + {"chunk-035b5966":"8f4c867b","chunk-05a32d20":"b352af10","chunk-09e7a5c2":"caa2134d","chunk-114ae655":"419b1ad4","chunk-12e40663":"6de52560","chunk-1391c3f6":"385560e0","chunk-161779b1":"74a3fbfa","chunk-1a140d81":"265b39c4","chunk-24a3b6f6":"9161b244","chunk-27750698":"0199ed80","chunk-2d05f858":"e00abc31","chunk-2d0ac23b":"071353f5","chunk-2d0ce784":"1bf95da4","chunk-2d0d5c9e":"660e9121","chunk-2d0dae27":"222d5888","chunk-2d20f202":"4ed0dad3","chunk-2d22d404":"7bf155c3","chunk-34feb6c4":"3c8bd05e","chunk-39712faa":"a03b5424","chunk-3da56cd3":"5acffed6","chunk-3ff9e160":"597316b7","chunk-45de6980":"0d18af70","chunk-45ee386a":"5d8c3a17","chunk-46df40e3":"9b09347d","chunk-470f7784":"ca1fb8d0","chunk-48606de6":"7580b48d","chunk-48fb7bbc":"61e7872d","chunk-4ae5ba8a":"25054e12","chunk-4c81e528":"1d329b23","chunk-4df6778e":"ab2801aa","chunk-5081289c":"c1366131","chunk-55be4bda":"bafe62a9","chunk-58e3f66e":"2d01ca7e","chunk-5cfb8742":"17735bc4","chunk-5ed2fbf6":"69f3dd88","chunk-5f84ccfa":"09f4bacf","chunk-6208ebdc":"9a778c2f","chunk-6e0fc165":"343032ef","chunk-780cabd3":"920ad6a0","chunk-7efaa700":"9d3964aa","chunk-82785576":"6d23dccd","chunk-8c64f80c":"fa57d434","chunk-8e9c50b6":"ba57e96f","chunk-8fa852b8":"bc18ba8f","chunk-947540a2":"4c10d513","chunk-9f1ac52c":"b60ed9d5","chunk-ad54cc74":"c586d8fa","chunk-b2965e40":"d9c00a19","chunk-bf4c5de4":"d47fd0f8","chunk-c11612da":"39b54f90","chunk-c9c8a6f8":"a5195611","chunk-d1e904ac":"6ed28953","chunk-d2e324d2":"b02375e9","chunk-d79d8dbe":"e4ac20a8","chunk-dae68ae8":"961fe121","chunk-dfa6f748":"1fe9e9f6","chunk-eb8e0ac8":"0d9467d9","chunk-efbc550a":"58bc9275","chunk-f4c39824":"c794765c","chunk-f80e636a":"e4610c4b","avalon-themeWrapLive":"2ea73c99","bb-themeWrap":"da3d971f","bb-themeWrapLive":"c52bf80d","betcoinsportsxmb-themeWrapLive":"3ff23beb","betflip-themeWrapLive":"788deae2","bmk-themeWrapLive":"298b34b6","chunk-076ff82a":"b0c25667","chunk-0ddc1de4":"c60788dc","chunk-37b458e0":"8c8aea39","chunk-77eb3c1c":"73943974","chunk-1d8a40d6":"c4b06bef","chunk-395d999a":"aa9651c4","chunk-50dba6fb":"f06d665c","chunk-534a25e4":"7564b850","chunk-5b2054f4":"fa2adc25","chunk-6dfe4027":"a1cbf59d","chunk-6ea3ac4c":"b8a5eee7","chunk-2d0e1776":"44f415bb","chunk-481db4bc":"b8e5eb02","chunk-8b78cf7c":"624759f1","chunk-af6cebae":"c6f5c22b","chunk-ec446aa4":"5f23a0fb","chunk-65f070b6":"ce5ef2f7","liveComponent":"43c1a14b","futurebet-themeWrapLive":"55d37897","hemingwaynew-themeWrapLive":"a092a99f","isiparyaj-themeWrapLive":"604265e5","lutrijabih-themeWrap":"313af33b","lutrijabihlive-themeWrap":"60b5e6c3","playbetr-themeWrapLive":"c06aa78e","powerbet-themeWrap":"3cdee906","powerbet-themeWrapLive":"0cd9494e","prematchModule":"266b2d40","sima-themeWrapLive":"5840e025","sportnaloterija-themeWrapLive":"79b22967","themeWrap":"39b9bd2e","themeWrapLive":"8ed82368","themeWrapLiveLight":"62b668c7","topbet-themeWrap":"b097acbf","victory-themeWrapLive":"7b39b2f6","wettnet-themeWrapLive":"ad339747","winner-themeWrap":"f07c1a8a","liveModule":"7617bf3f","seven-theme":"e197f007","winner-theme":"ff602fd6","winnerbet-theme":"d7d22a47"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-035b5966":1,"chunk-05a32d20":1,"chunk-09e7a5c2":1,"chunk-114ae655":1,"chunk-46df40e3":1,"chunk-4c81e528":1,"chunk-55be4bda":1,"chunk-5cfb8742":1,"chunk-5f84ccfa":1,"chunk-6208ebdc":1,"chunk-82785576":1,"chunk-947540a2":1,"chunk-9f1ac52c":1,"chunk-ad54cc74":1,"chunk-bf4c5de4":1,"chunk-c9c8a6f8":1,"chunk-d1e904ac":1,"chunk-d79d8dbe":1,"chunk-eb8e0ac8":1,"chunk-f80e636a":1,"avalon-themeWrapLive":1,"bb-themeWrap":1,"bb-themeWrapLive":1,"betcoinsportsxmb-themeWrapLive":1,"betflip-themeWrapLive":1,"bmk-themeWrapLive":1,"chunk-076ff82a":1,"chunk-77eb3c1c":1,"chunk-1d8a40d6":1,"chunk-395d999a":1,"chunk-534a25e4":1,"chunk-5b2054f4":1,"chunk-6dfe4027":1,"chunk-6ea3ac4c":1,"chunk-8b78cf7c":1,"chunk-af6cebae":1,"futurebet-themeWrapLive":1,"hemingwaynew-themeWrapLive":1,"isiparyaj-themeWrapLive":1,"lutrijabih-themeWrap":1,"lutrijabihlive-themeWrap":1,"playbetr-themeWrapLive":1,"powerbet-themeWrap":1,"powerbet-themeWrapLive":1,"sima-themeWrapLive":1,"sportnaloterija-themeWrapLive":1,"themeWrap":1,"themeWrapLive":1,"themeWrapLiveLight":1,"topbet-themeWrap":1,"victory-themeWrapLive":1,"wettnet-themeWrapLive":1,"seven-theme":1,"winner-theme":1,"winnerbet-theme":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"avalon-themeWrapLive":"avalon-themeWrapLive","bb-themeWrap":"bb-themeWrap","bb-themeWrapLive":"bb-themeWrapLive","betcoinsportsxmb-themeWrapLive":"betcoinsportsxmb-themeWrapLive","betflip-themeWrapLive":"betflip-themeWrapLive","bmk-themeWrapLive":"bmk-themeWrapLive","liveComponent":"liveComponent","futurebet-themeWrapLive":"futurebet-themeWrapLive","hemingwaynew-themeWrapLive":"hemingwaynew-themeWrapLive","isiparyaj-themeWrapLive":"isiparyaj-themeWrapLive","lutrijabih-themeWrap":"lutrijabih-themeWrap","lutrijabihlive-themeWrap":"lutrijabihlive-themeWrap","playbetr-themeWrapLive":"playbetr-themeWrapLive","powerbet-themeWrap":"powerbet-themeWrap","powerbet-themeWrapLive":"powerbet-themeWrapLive","prematchModule":"prematchModule","sima-themeWrapLive":"sima-themeWrapLive","sportnaloterija-themeWrapLive":"sportnaloterija-themeWrapLive","themeWrap":"themeWrap","themeWrapLive":"themeWrapLive","themeWrapLiveLight":"themeWrapLiveLight","topbet-themeWrap":"topbet-themeWrap","victory-themeWrapLive":"victory-themeWrapLive","wettnet-themeWrapLive":"wettnet-themeWrapLive","winner-themeWrap":"winner-themeWrap","liveModule":"liveModule","seven-theme":"seven-theme","winner-theme":"winner-theme","winnerbet-theme":"winnerbet-theme"}[chunkId]||chunkId) + "." + {"chunk-035b5966":"9ab7807b","chunk-05a32d20":"4b483dba","chunk-09e7a5c2":"9226e5f0","chunk-114ae655":"4c60b059","chunk-12e40663":"31d6cfe0","chunk-1391c3f6":"31d6cfe0","chunk-161779b1":"31d6cfe0","chunk-1a140d81":"31d6cfe0","chunk-24a3b6f6":"31d6cfe0","chunk-27750698":"31d6cfe0","chunk-2d05f858":"31d6cfe0","chunk-2d0ac23b":"31d6cfe0","chunk-2d0ce784":"31d6cfe0","chunk-2d0d5c9e":"31d6cfe0","chunk-2d0dae27":"31d6cfe0","chunk-2d20f202":"31d6cfe0","chunk-2d22d404":"31d6cfe0","chunk-34feb6c4":"31d6cfe0","chunk-39712faa":"31d6cfe0","chunk-3da56cd3":"31d6cfe0","chunk-3ff9e160":"31d6cfe0","chunk-45de6980":"31d6cfe0","chunk-45ee386a":"31d6cfe0","chunk-46df40e3":"9178aab5","chunk-470f7784":"31d6cfe0","chunk-48606de6":"31d6cfe0","chunk-48fb7bbc":"31d6cfe0","chunk-4ae5ba8a":"31d6cfe0","chunk-4c81e528":"acbb924b","chunk-4df6778e":"31d6cfe0","chunk-5081289c":"31d6cfe0","chunk-55be4bda":"56de9bae","chunk-58e3f66e":"31d6cfe0","chunk-5cfb8742":"9573c02d","chunk-5ed2fbf6":"31d6cfe0","chunk-5f84ccfa":"56fb6014","chunk-6208ebdc":"8cd663d2","chunk-6e0fc165":"31d6cfe0","chunk-780cabd3":"31d6cfe0","chunk-7efaa700":"31d6cfe0","chunk-82785576":"b95a75de","chunk-8c64f80c":"31d6cfe0","chunk-8e9c50b6":"31d6cfe0","chunk-8fa852b8":"31d6cfe0","chunk-947540a2":"f4fd9d9b","chunk-9f1ac52c":"4da48453","chunk-ad54cc74":"447cd2c8","chunk-b2965e40":"31d6cfe0","chunk-bf4c5de4":"63fbf16b","chunk-c11612da":"31d6cfe0","chunk-c9c8a6f8":"81ea3308","chunk-d1e904ac":"8f647163","chunk-d2e324d2":"31d6cfe0","chunk-d79d8dbe":"e40b804e","chunk-dae68ae8":"31d6cfe0","chunk-dfa6f748":"31d6cfe0","chunk-eb8e0ac8":"096208fa","chunk-efbc550a":"31d6cfe0","chunk-f4c39824":"31d6cfe0","chunk-f80e636a":"c1dd1153","avalon-themeWrapLive":"faf2d477","bb-themeWrap":"5474dfe5","bb-themeWrapLive":"56a98b37","betcoinsportsxmb-themeWrapLive":"634d819a","betflip-themeWrapLive":"7a37142f","bmk-themeWrapLive":"7098805c","chunk-076ff82a":"ad3ecd12","chunk-0ddc1de4":"31d6cfe0","chunk-37b458e0":"31d6cfe0","chunk-77eb3c1c":"da0e52a9","chunk-1d8a40d6":"f335100f","chunk-395d999a":"923a0d0e","chunk-50dba6fb":"31d6cfe0","chunk-534a25e4":"883a6cd0","chunk-5b2054f4":"3dc2cf22","chunk-6dfe4027":"ea9f214c","chunk-6ea3ac4c":"6e51e735","chunk-2d0e1776":"31d6cfe0","chunk-481db4bc":"31d6cfe0","chunk-8b78cf7c":"fbd206a2","chunk-af6cebae":"6a7af2c3","chunk-ec446aa4":"31d6cfe0","chunk-65f070b6":"31d6cfe0","liveComponent":"31d6cfe0","futurebet-themeWrapLive":"7f088620","hemingwaynew-themeWrapLive":"7098805c","isiparyaj-themeWrapLive":"b5ec3658","lutrijabih-themeWrap":"3d27cc80","lutrijabihlive-themeWrap":"ffd8eced","playbetr-themeWrapLive":"9a5257f4","powerbet-themeWrap":"e651742b","powerbet-themeWrapLive":"3b9de4ef","prematchModule":"31d6cfe0","sima-themeWrapLive":"a37c5313","sportnaloterija-themeWrapLive":"78c0b2d5","themeWrap":"6815ed95","themeWrapLive":"ec6a6af2","themeWrapLiveLight":"48568f58","topbet-themeWrap":"21d58845","victory-themeWrapLive":"faf2d477","wettnet-themeWrapLive":"b1927f57","winner-themeWrap":"31d6cfe0","liveModule":"31d6cfe0","seven-theme":"2306f623","winner-theme":"c1429838","winnerbet-theme":"ee892408"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors~253ae210","chunk-vendors~9c5b28f6"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
